/**
 * سیستم مدیریت تاریخچه منوها
 * کپی شده از فرانت قدیم FoodMenu.jsx
 */
import moment from 'jalali-moment';

/**
 * به‌روزرسانی تاریخچه منو
 * @param {string} date - تاریخ
 * @param {string} meal - وعده غذایی
 * @param {number} menuId - شناسه منو
 * @param {Object} selectedMenusHistory - تاریخچه منوهای انتخاب شده
 * @returns {Object} - تاریخچه به‌روزرسانی شده
 */
export const updateMenuHistory = (date, meal, menuId, selectedMenusHistory) => {
  const menuIdStr = String(menuId);
  const currentWeekStart = moment().startOf('week').format('YYYY/MM/DD');
  
  // ایجاد کپی از تاریخچه
  const newHistory = {
    daily: [...selectedMenusHistory.daily],
    weekly: { ...selectedMenusHistory.weekly },
    weekStart: selectedMenusHistory.weekStart || currentWeekStart
  };
  
  // ریست weekly اگر هفته عوض شده
  if (newHistory.weekStart !== currentWeekStart) {
    newHistory.weekly = {};
    newHistory.weekStart = currentWeekStart;
  }
  
  // به‌روزرسانی daily
  newHistory.daily.push({ date, meal, menuId: menuIdStr });
  
  // به‌روزرسانی weekly
  newHistory.weekly[menuIdStr] = newHistory.weekly[menuIdStr] || {};
  newHistory.weekly[menuIdStr][meal] = (newHistory.weekly[menuIdStr][meal] || 0) + 1;
  
  console.log(`[به‌روزرسانی تاریخچه] ${meal} | menuId: ${menuIdStr}, تاریخ: ${date}, weeklyCount: ${newHistory.weekly[menuIdStr][meal]}`);
  
  return newHistory;
};

